import * as json from 'multiformats/codecs/json';
import { resolveObjectPath } from '../utils/resolve-object-path.js';
const resolve = async (cid, name, path, toResolve, resolve, depth, blockstore, options) => {
    const block = await blockstore.get(cid, options);
    const object = json.decode(block);
    return resolveObjectPath(object, block, cid, name, path, toResolve, depth);
};
export default resolve;
//# sourceMappingURL=json.js.map